import { render, staticRenderFns } from "./beforeUpated.vue?vue&type=template&id=0c0d69d0&scoped=true&lang=pug&"
import script from "./beforeUpated.vue?vue&type=script&lang=js&"
export * from "./beforeUpated.vue?vue&type=script&lang=js&"
import style0 from "./beforeUpated.vue?vue&type=style&index=0&id=0c0d69d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0d69d0",
  null
  
)

export default component.exports